import React from 'react';

const SecondaryButton = ({ children, className = '', ...props }) => (
  <button
    type="button"
    className={`secondary-outline-btn fw-bold rounded ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default SecondaryButton; 